import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const AdminGroupEditMembersEditListItem = ({ user, handleRemove }) => {
  if (!user) {
    return null;
  }

  return (
    <div className="user-item">
      {user.avatar_url ? (
        <div className="user-avatar">
          <img src={user.avatar_url} alt={user.display_name} className="avatar avatar-40" />
        </div>
      ) : (
        <div className="user-avatar">
          <div className="avatar avatar-40 icon-avatar gray">
            <i className="fas fa-user" />
          </div>
        </div>
      )}
      <div className="user-item-body">
        <h6 className="user-item-title">
          <div className="user-avatar">
            {user.name}
          </div>
        </h6>
        <span className="user-item-details">
          {user.email}
        </span>
      </div>
      <div className="user-item-actions">
        <Button
          color="link"
          onClick={(e) => {
            e.preventDefault();
            handleRemove(user.uuid);
          }}
        >
          <i className="far fa-trash" />
        </Button>
      </div>
    </div>
  );
};

AdminGroupEditMembersEditListItem.propTypes = {
  user: PropTypes.object.isRequired,
  handleRemove: PropTypes.func.isRequired,
};

export default AdminGroupEditMembersEditListItem;
